import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import { SPACING_4 } from 'constants/theme-constants';
import styled from 'styled-components';

export const TooltipContent = styled.span`
  ${({ theme }) => `
    display: block;
    max-width: 240px;
    padding: ${cxTheme.spacing[SPACING_4]};
    ${theme.paragraph.small.normal}
    border-radius: ${cxTheme.borderRadius.primaryRadius};
    background: ${theme.background.raised};
    color: ${theme.text.onSurface.strong};
    box-shadow: ${theme.elevation.level2};
  `}
`;
